import { ConfigProvider, Modal, Spin } from "antd"
import React, { FC, useState } from "react"
import { useNavigate } from "react-router"
import { useDeleteNotificationMutation } from "../../../../../../../graphql"
import { ReactComponent as DangerInfoIcon } from "../../../../../../../icons/danger-info.svg"
import Form from "./components/Form"
import "./index.less"

const LeftSide: FC<NotificationManageBlockLeftSideInterface> = ({
  options,
  filters,
  setOptions,
  setFilters,
  notification,
  eventTypeId,
  customTypeId,
  initialFilters,
  isChangesDisabled,
  setInitialFilters,
  selectedNotificationId,
}) => {
  const navigate = useNavigate()

  const [deleteNotification] = useDeleteNotificationMutation()

  const [modalLoading, setModalLoading] = useState<boolean>(false)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleModalOk = async () => {
    setModalLoading(true)

    try {
      const response = await deleteNotification({
        variables: {
          id: String(selectedNotificationId),
        },
      })
      if (response?.data?.deleteAppNotification?.data?.id) {
        setIsModalOpen(false)
        setTimeout(() => {
          navigate("/account/content/notifications")
        }, 500)
      }

      setModalLoading(false)
    } catch (error) {
      setModalLoading(false)
    }
  }

  const handleModalCancel = () => {
    setIsModalOpen(false)
  }

  return (
    <div className={"left-side-wrapper"}>
      <ConfigProvider
        theme={{
          components: {
            Input: {
              colorBorder: "#ffffff",
              colorPrimaryHover: "#ffffff",
              controlOutline: "#ffffff",
              colorError: "#ffffff",
              colorErrorBorderHover: "#ffffff",
              colorErrorOutline: "#ffffff",
              colorIcon: "#1C1C23",
              borderRadius: 0,
            },
            Select: {
              colorText: "#000",
              colorPrimaryBorder: "#fff",
              colorPrimaryHover: "#fff",
              controlOutline: "#fff",
              colorBgContainerDisabled: "#fff",
              colorBorder: "#fff",
            },
            Button: {
              borderRadius: 0,
              colorBorder: "#000",
              colorPrimary: "#000",
              colorPrimaryHover: "#707070",
              colorText: "#000",
            },
            Calendar: {
              colorPrimary: "#000",
              colorPrimaryHover: "#707070",
            },
          },
        }}
      >
        <Form
          {...{
            options,
            filters,
            showModal,
            setOptions,
            setFilters,
            eventTypeId,
            customTypeId,
            notification,
            initialFilters,
            isChangesDisabled,
            setInitialFilters,
            selectedNotificationId,
          }}
        />

        <Modal open={isModalOpen} onOk={handleModalOk} onCancel={handleModalCancel} className={"notification"}>
          <div className={"modal-content-wrapper"}>
            <DangerInfoIcon />
            <p>Are you sure you want to delete an existing notification?</p>
            <div className={"loading"}>{modalLoading && <Spin />}</div>
          </div>
        </Modal>
      </ConfigProvider>
    </div>
  )
}

export default LeftSide
